module.exports = __webpack_public_path__ + "img/spinner.45e22144.svg";